import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {State} from 'src/app/store';
import * as actions from '../../../../store/auth/authentication.actions';
import * as selectors from '../../../../store/auth/authentication.selectors';
import * as selectorsApp from '../../../../store/app/app.selectors';
import {selectAppViewPort} from '../../../../store/app/app.selectors';
import {AuthenticationService} from '../../../../store/auth/authentication.service';
import * as appActions from '../../../../store/app/app.actions';
import {environment} from '../../../../../environments/environment';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewChecked {
  login_form: FormGroup;
  login_spinner = false;

  error_message = '';
  route_from = '';
  route_email = '';
  validated_account = '';

  platformBrandLogo = '';
  platformLandingPage = '';
  platformName = '';
  viewport = '';
  returnUrl;

  private subscriptions = [];

  loginToken;
  loading = true;

  constructor(
    public store: Store<State>,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private _authenticationService: AuthenticationService,
  ) {
    this.loginToken = this.activatedRoute.params['value'].login_token;
  }

  ngOnInit() {
      this.loading = true;
      this.store.select(selectAppViewPort).subscribe(result => {
          this.viewport = result;
      });
      this.store.dispatch(appActions.getPublicUserGroup({typeUserGroup: 'platform_id',  queryValue: environment.platform_id }));
      this.login_form = new FormGroup({
      email: new FormControl(this.route_email, [
        Validators.required,
        Validators.pattern(
          '^[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$'
        ),
      ]),
      password: new FormControl('', Validators.required),
    });
    this.returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'] || '/';

    // comprobamos si viene token para realizar el autologin
    if (this.loginToken !== undefined ) {
      this.subscriptions.push(
        this._authenticationService.autoLogin(this.loginToken).subscribe( response => {
          this.store.dispatch(
            actions.loginUser({
              user: {
                username: response.body['username'],
                password: response.body['password'],
              },
              returnUrl: this.returnUrl,
            })
          );
        }, () => {
            setTimeout( () => { this.loading = false; document.querySelector('app-login').classList.add('active'); }, 800 );
        })
      );
      // this._authenticationService.autoLogin(this.loginToken);
    } else {
      this.subscriptions.push(
        // Check if client comes from register,
        // resend validation email or forgot password, to set email field
        this.activatedRoute.queryParams.subscribe(params => {
          if (typeof params.email === 'string' && params.email !== '') {
            this.login_form.controls.email.setValue(params.email);
          }
          this.route_from = params['from'];
          this.route_email = params['email'];
          this.validated_account = params['validated_account'];
        }),
        this.store.select(selectors.selectLoadingError).subscribe(errMessage => {
          this.error_message = errMessage;
        }),
        this.store.select(selectors.selectLoginLoading).subscribe(loading => {
          this.login_spinner = loading;
        }),
      );
      setTimeout( () => { this.loading = false; document.querySelector('app-login').classList.add('active'); }, 1500 );
    }
  }

  ngAfterViewChecked() {
      this.subscriptions.push(
          this.store.select(selectorsApp.selectUserGroup).subscribe(userGroup => {
              if (userGroup !== null ) {
                  this.platformBrandLogo = userGroup.logo_login_url;
                  this.platformName = userGroup.platform_name;
                  this.platformLandingPage = userGroup.landing_page;
                  this.cdr.detectChanges();
              }
          })
      );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.store.dispatch(actions.clearErrors());
  }

  login() {
    if (this.login_form.status !== 'INVALID') {
      this.store.dispatch(
        actions.loginUser({
          user: {
            username: this.login_form.value.email,
            password: this.login_form.value.password,
          },
          returnUrl: this.returnUrl,
        })
      );
      this.loading = false;
    }
  }
}
